<template>
  <div v-if="visible" class="modal-overlay" @click="handleClose">
    <div class="modal-content" @click.stop>
      <h2 class="modal-title">历史记录</h2>
      <div class="modal-close" @click="handleClose">×</div>
      <div v-if="historyRecords.length === 0" class="empty-tip">暂无历史记录</div>
      <div v-else class="history-list">
        <div v-for="(record) in historyRecords" :key="record.id" class="history-item">
          <div class="history-info">
            <div class="history-time">{{ record.time }}</div>
            <div class="history-detail">总金额：{{ record.form.totalAmount }}元</div>
            <div class="history-persons">参与人：{{ record.form.personList.map(p => p.name).join('、') }}</div>
          </div>
          <button @click="handleDelete(record.id)" class="btn btn-delete-small">删除</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HistoryModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    historyRecords: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.$emit('close');
    },
    
    // 删除历史记录
    handleDelete(id) {
      if (confirm("确定删除？删除后无法恢复！")) {
        this.$emit('delete', id);
      }
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  max-width: 600px;
  width: 90%;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
}

.modal-title {
  font-size: 18px;
  font-weight: bold;
  color: #333;
  margin-bottom: 15px;
  padding-bottom: 10px;
  border-bottom: 2px solid #42b983;
}

.modal-close {
  position: absolute;
  top: 15px;
  right: 15px;
  font-size: 24px;
  cursor: pointer;
  color: #999;
  transition: color 0.3s;
}

.modal-close:hover {
  color: #333;
}

.empty-tip {
  text-align: center;
  color: #999;
  padding: 40px 0;
  font-size: 16px;
}

.history-list {
  margin-top: 15px;
}

.history-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px;
  background: #f9f9f9;
  border-radius: 4px;
  margin-bottom: 10px;
  border-left: 4px solid #42b983;
}

.history-info {
  flex: 1;
}

.history-time {
  font-size: 14px;
  color: #666;
  margin-bottom: 5px;
}

.history-detail {
  font-size: 14px;
  color: #333;
  margin-bottom: 5px;
}

.history-persons {
  font-size: 12px;
  color: #999;
}

.btn {
  padding: 4px 8px;
  font-size: 12px;
  background: #f44336;
  color: #fff;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
  font-weight: bold;
}

.btn:hover {
  background: #e53935;
  transform: translateY(-1px);
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

/* 响应式布局 - 移动端适配 */
@media (max-width: 750px) {
  .history-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .history-item .btn {
    width: auto;
    margin-top: 10px;
  }
}
</style>